"use strict";
import React from "react";
import ReactUtils from "../../react_utils";
var bem = ReactUtils.makeBem("pod-shipment-selector");
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "pod-shipment-selector" }, /* @__PURE__ */ React.createElement("h3", { className: bem("__title") }, "Link customer docs to shipments"), /* @__PURE__ */ React.createElement("ul", { className: bem("__list") }, this.props.shipmentDocumentSelections.map(
      (shipmentDocumentSelection) => {
        return this.shipmentSelector(shipmentDocumentSelection);
      }
    )));
  },
  shipmentSelector: function(shipmentDocumentSelection) {
    const shipment = shipmentDocumentSelection.shipment;
    const selectedDocuments = shipmentDocumentSelection.documents;
    const isChecked = selectedDocuments.some(
      (doc) => doc.id == this.props.selectedDocument.id
    );
    let shipmentLabel = shipment.shipment_external_id;
    if (shipment.customer_name) {
      shipmentLabel += ` for ${shipment.customer_name}`;
    }
    return /* @__PURE__ */ React.createElement(
      "li",
      {
        key: shipment.id,
        className: bem("__list-item"),
        onClick: () => this.props.toggleShipmentDocument(
          shipment.id,
          this.props.selectedDocument
        )
      },
      /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: isChecked,
          className: bem("__checkbox")
        }
      ),
      /* @__PURE__ */ React.createElement("label", { className: bem("__label") }, shipmentLabel, this.linkedDocumentsLabel(selectedDocuments))
    );
  },
  linkedDocumentsLabel: function(selectedDocuments) {
    if (selectedDocuments.length == 0) {
      return null;
    } else if (selectedDocuments.length == 1) {
      const docType = selectedDocuments[0].type_name;
      return /* @__PURE__ */ React.createElement("span", { className: bem("__linked-documents") }, docType, " linked");
    } else {
      return /* @__PURE__ */ React.createElement("span", { className: bem("__linked-documents") }, selectedDocuments.length, " Docs linked");
    }
  }
});
